import { authHeader } from "../../../auth";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                ckfinder: {
                    // The URL of your file repository.
                    uploadUrl: this.$serverURL + this.$api.editor.uploadFileURL,
                }
            },
            setURL: this.$serverURL + this.$api.retailer.meta,

            retailer: [],
            retailerList: [],

            contactPageTitle: "",
            contactMetaDescription: "",
            contactMetaKeyword: "",
            contactCanonicalTag: "",
            storePageTitle: "",
            storeMetaDescription: "",
            storeMetaKeyword: "",
            storeCanonicalTag: "",
        }

    },
    async created() {
        document.title = "Dispo - Add Retailer Meta Data";
        await this.getRetailerList();
    },
    methods: {
        checkValidation: function () {
            if (!(Object.keys(this.retailer).length)) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please select retailer!"
                });
                return false;
            }
            return true;
        },
        addRetailerMeta: async function () {
            if (this.checkValidation()) {
                try {
                    this.$swal.showLoading();
                    const payload = {
                        retailerId: this.retailer.value.id,
                        retailerName: this.retailer.value.name,
                        contactPageTitle: this.contactPageTitle,
                        contactMetaDescription: this.contactMetaDescription,
                        contactMetaKeyword: this.contactMetaKeyword,
                        contactCanonicalTag: this.contactCanonicalTag,
                        storePageTitle: this.storePageTitle,
                        storeMetaDescription: this.storeMetaDescription,
                        storeMetaKeyword: this.storeMetaKeyword,
                        storeCanonicalTag: this.storeCanonicalTag,
                    }

                    const config = {
                        method: 'POST',
                        url: this.setURL,
                        data: payload,
                        headers: {
                            ...authHeader(),
                        }
                    };
                    await this.$axios(config).then((response) => {
                        if (response.status == 201) {
                            this.$swal.fire({
                                toast: true,
                                position: 'top-end',
                                text: response.data.message,
                                icon: "success",
                                showConfirmButton: false,
                                timer: 3000,
                                animation: false,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                                }
                            });
                        }
                        this.retailer = [],
                            this.contactPageTitle = "",
                            this.contactMetaDescription = "",
                            this.contactMetaKeyword = "",
                            this.contactCanonicalTag = "",
                            this.storePageTitle = "",
                            this.storeMetaDescription = "",
                            this.storeMetaKeyword = "",
                            this.storeCanonicalTag = "",
                            this.$router.push("/retailer-meta-data");
                    }).catch(error => {
                        this.$swal.fire({
                            icon: "error",
                            text: error.response.data.message
                        });
                    });
                } catch (error) {
                    this.$swal.hideLoading();
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong. Please try again! " + error
                    });
                }
            }
        },
        getRetailerList: async function () {
            const url = this.$serverURL + this.$api.store.requestURL;
            const config = {
                method: "POST",
                url: url,
                headers: {
                    ...authHeader()
                }
            }
            await this.$axios(config).then(async (response) => {
                if (response.status == 200) {
                    this.retailerList = response.data.map((el) => {
                        return { value: el, label: `${el.name}` };
                    });
                }
                else {
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                }
            }).catch(error => {
                console.log(error);
                this.$swal.fire({
                    icon: "error",
                    text: "Failed! please try again." + error
                });
            });
        }
    },
}